// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Pwy2L","validationTips":"StatementDescriptor_validationTips__r3QhV"};